document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    const swiper = new Swiper('.carousel-images .swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1.2,
      spaceBetween: 16,

      breakpoints: {
        991: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
  if (typeof GLightbox !== 'undefined') {
    const lightbox = GLightbox({ selector: '.carousel-images .carousel--item__link' });
  }
});
